export class DoctorDataModel {
    DoctorName: string;
    DoctorCode: string;
    DEPT_CODE: string;
    SLOT: string;
    TotalSlot: string;
    BookSlot: string;
    DAYS: string;
    QUALIFICATION   : string;
    DESIGNATION: string;
    SPECIALITY: string;
    IMAGE_NAME: string;
    DEPTNAME: string;
    ImageByte: string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/doctordatamodel.ts